import React from "react";
import {colors} from "../../utils/styled/_variables.styled";
import Icon from "../Icon/Icon";
import {InfiosThankYouMessage} from "./ThankYouMessage.style";

const ThankYouMessage = (props) => {
    const { thankYouTitle, thankYouText } = props;


    return (
        <InfiosThankYouMessage data-analytics="submit__success">
            <Icon icon="check-circle" color={colors.success} />
            <div className="content-wrapper">
                <span className="heading-4 title">{thankYouTitle || "Thank you for your message."}</span>
                <span className="p-regular text">{thankYouText || "We have just sent you a confirmation email. We will address your request as soon as possible."}</span>
            </div>
        </InfiosThankYouMessage>
    )
}

export default ThankYouMessage;
